import { ExchangeId } from "../types";

export type LightningStatus = "active" | "disabled" | "unsupported";

export interface WithdrawalLimitMetaItem {
  value: string;
  detail?: string;
  note?: string;
  href?: string;
}

export interface WithdrawalLimitMeta {
  btc?: WithdrawalLimitMetaItem;
  toman?: WithdrawalLimitMetaItem;
}

export interface FeeSummaryMeta {
  maxTakerFee: number;
  href?: string;
}

export interface ExchangeMeta {
  withdrawalFeeBtc: number;
  supportsLightning: boolean;
  lightningStatus: LightningStatus;
  lightningNote?: string;
  takerFee: number;
  usdtToman?: number;
  withdrawalLimits: WithdrawalLimitMeta;
  feeSummary: FeeSummaryMeta;
}

export const EXCHANGE_META: Record<ExchangeId, ExchangeMeta> = {
  nobitex: {
    withdrawalFeeBtc: 0.00005,
    supportsLightning: true,
    lightningStatus: "active",
    lightningNote: undefined,
    takerFee: 0.0025,
    usdtToman: undefined,
    withdrawalLimits: {
      btc: {
        value: "از معادل ۳۰۰ میلیون تومان",
        href: "https://nobitex.ir/panel/verification/?refcode=8D67647",
      },
      toman: {
        value: "از ۳۰۰ میلیون تومان",
        href: "https://nobitex.ir/panel/verification/?refcode=8D67647",
        note: "هر شماره شبا ۲۰۰ میلیون تومان",
      },
    },
    feeSummary: {
      maxTakerFee: 0.0025,
      href: "https://nobitex.ir/pricing/?refcode=8D67647",
    },
  },
  wallex: {
    withdrawalFeeBtc: 0.00017,
    supportsLightning: false,
    lightningStatus: "unsupported",
    lightningNote: undefined,
    takerFee: 0.003,
    usdtToman: undefined,
    withdrawalLimits: {
      btc: {
        value: "بدون محدودیت",
        href: "https://wallex.ir/app/wallet/crypto-withdraw/btc?ref=77dz8xdq"
      },
      toman: {
        value: "از ۱۰۰ میلیون تومان",
        href: "https://wallex.ir/commission?ref=77dz8xdq",
        note: "هر شماره شبا ۱۰۰ میلیون تومان"
      },
    },
    feeSummary: {
      maxTakerFee: 0.003,
      href: "https://wallex.ir/commission?ref=77dz8xdq"
    },
  },
  bitpin: {
    withdrawalFeeBtc: 0.00008000,
    supportsLightning: true,
    lightningStatus: "disabled",
    lightningNote: "لایتنینگ موقتاً غیرفعال است",
    takerFee: 0.0035,
    usdtToman: undefined,
    withdrawalLimits: {
      btc: {
        value: "بدون محدودیت",
      },
      toman: {
        value: "۲۰۰ میلیون تومان",
        note: "هر شماره شبا ۱۰۰ میلیون تومان"
      },
    },
    feeSummary: {
      maxTakerFee: 0.0035,
      href: "https://bitpin.ir/fee?refcode=fv2j04oqwy"
    },
  },
};
